import { apiClient } from '@/services/api';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS } from '@/settings/api-settings';
import ITeam, { TimeParmDTO } from '@/interfaces/teams';

function getTeam(id: string): Observable<ITeam> {
  return from(apiClient.get(`${ENDPOINTS.TEAM}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}

function saveTeam(payload: TimeParmDTO): Observable<any> {
  return from(apiClient.post(ENDPOINTS.TEAM, payload)).pipe(
    map((r: any) => r.data),
  );
}

function updateTeam(team: TimeParmDTO): Observable<any> {
  return from(apiClient.put(ENDPOINTS.TEAM, team)).pipe(
    map((r: any) => r.data),
  );
}

function getTeams(filter: any = {}): Observable<any[]> {
  return from(apiClient.get(ENDPOINTS.TEAM, filter)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export function listTeamsCombo(idsClientUnit: number[]): Observable<any[]> {
  return from(apiClient.get(ENDPOINTS.TEAM_COMBO, {idsUnidadeCliente: idsClientUnit})).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

function getTeamsByClient(idUnidade: any, filter: any = {}): Observable<any[]> {
  return from(
    apiClient.get(`${ENDPOINTS.TEAM}/unidade/${idUnidade}`, filter),
  ).pipe(map((r: any) => (!!r.data ? r.data : [])));
}

export { getTeams, getTeam, saveTeam, updateTeam, getTeamsByClient };
